export const defaultPhoto = 'assets/common/icons/branch-logo-dummy.svg';
